import { authenticatedFetch } from "@/services/utils/authenticatedFetch";

/**
 * Check if a blob with the given title is indexed in Azure AI Search
 * @param title - The title/name of the blob to check
 * @returns Promise<boolean> - true if the blob is indexed, false otherwise
 */
export async function checkBlobIndexed(title: string): Promise<boolean> {
  try {
    const response = await authenticatedFetch("/api/ai-search/check-indexed", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ title }),
    });

    if (!response.ok) {
      console.warn(`Failed to check blob indexing status: ${response.status}`);
      return false;
    }

    return await response.json();
  } catch (error) {
    console.error("Error checking blob indexing status:", error);
    return false;
  }
}
